import React from "react";

function SpotifyPlayer() {
  return (
    <div style={{ maxWidth: "500px" }}>
      <iframe
        src="https://open.spotify.com/embed/episode/5GzChXPMs9TSVDHO25puFm"
        width="100%"
        height="250"
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        title="Spotify Player"
      ></iframe>
    </div>
  );
}

export default SpotifyPlayer;